import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, DOCUMENT } from '@angular/core';
import { lastValueFrom, map, Observable, shareReplay } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IState } from '../models/state';
import { SiteOptions } from '../models/site-options';
import { Title } from '@angular/platform-browser';
import { LogoDetails } from '../models/logo-details';


import { palette, updatePrimaryPalette } from '@primeng/themes';

@Injectable({
  providedIn: 'root',
})
export class UtilityService {
  private _siteOptions!: SiteOptions;
  private _states!: IState[];

  constructor(
    private http: HttpClient,
    private titleService: Title,
    @Inject(DOCUMENT) private document: Document
  ) {}

  get siteOptions() {
    if (!this._siteOptions) {
      throw Error('Site Options not loaded!');
    }
    return this._siteOptions;
  }

  get siteLogo(): LogoDetails {
    var dealerTypeId: number = environment.dealerTypeId ?? 0;
    var logo: LogoDetails;
    switch (dealerTypeId) {
      case 1:
        logo = { path: 'assets/svg/Valley.svg', height: 72 };
        break;
      case 2:
        logo = { path: 'assets/svg/Zimmatic.svg', height: 72 };
        break;

      default:
        logo = { path: 'assets/svg/No-logo.svg', height: 72 };

        break;
    }
    return logo;
  }

  get statesList() {
    if (!this._states) {
      throw Error('States list did not load!');
    }
    return this._states.sort((a, b) => {
      const nameA = a.name.toUpperCase();
      const nameB = b.name.toUpperCase();
      return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
    });
  }

  async loadSiteConfigurations() {
    const getOptions = this.getSiteOptions();
    const getStates = this.getStatesList();

    await lastValueFrom(getStates).then((data) => {
      this._states = data;
    });

    return await lastValueFrom(getOptions).then((data) => {
      this._siteOptions = data;
      this.titleService.setTitle(data.tabTitle);
      this.setSiteThemes(data.dealerTypeId);
    });
  }

  private getStatesList(): Observable<IState[]> {
    return this.http.get<IState[]>(`${environment.apiUrl}/utility/states`).pipe(
      map((value: any) => {
        return value;
      }),
      shareReplay({ refCount: true, bufferSize: 1 })
    );
  }

  private getSiteOptions(): Observable<SiteOptions> {
    return this.http
      .get<SiteOptions[]>(
        `${environment.apiUrl}/utility/options/${environment.dealerTypeId}`
      )
      .pipe(
        map((value: any) => {
          return value;
        }),
        shareReplay({ refCount: true, bufferSize: 1 })
      );
  }

  private setSiteThemes(dealerTypeId: number) {
    var primaryColor: string;

    switch (dealerTypeId) {
      case 1:
        primaryColor = '#1174c0';
        break;
      case 2:
        primaryColor = '#9b2743';
        break;
      default:
        primaryColor = '#5f656b';
        break;
    }

    const primaryColorArray = palette(primaryColor);
    updatePrimaryPalette(primaryColorArray);
  }
}
